export const translations = {
  en: {
    // Common
    welcome: "Welcome",
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    close: "Close",
    back: "Back",
    next: "Next",
    submit: "Submit",
    download: "Download",
    upload: "Upload",
    search: "Search",
    filter: "Filter",
    yes: "Yes",
    no: "No",

    // Authentication
    signIn: "Sign In",
    signOut: "Sign Out",
    email: "Email",
    password: "Password",
    employeeId: "Employee ID",
    employeeIdOrEmail: "Employee ID or Email",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    changePassword: "Change Password",
    sessionExpired: "Your session has expired. Please sign in again.",
    forgotPassword:
      "For password reset, send a WhatsApp message to Mata: 050-585-6068",

    // 2FA
    twoFactorAuth: "Two-Factor Authentication",
    enable2FA: "Enable 2FA",
    disable2FA: "Disable 2FA",
    twoFAEnabled: "2FA Enabled",
    twoFARequired: "2FA required",
    enterCode: "Enter the code from your authenticator app",
    backupCode: "Backup Code",
    useBackupCode: "Use Backup Code",
    useAuthenticatorCode: "Use Authenticator Code",
    scanQRCode: "Scan QR Code",
    setupTwoFA: "Setup Two-Factor Authentication",
    disable2FAWarning:
      "Disabling 2FA will make your account less secure. You'll only need your password to login.",
    confirmPassword2FA: "Confirm Your Password",

    // Authenticator mode
    authenticatorModeHint: "Enter your employee ID to continue",
    authenticatorSetupRequired:
      "Your account requires authenticator setup before you can log in",
    authenticatorSetupDesc:
      "You will need to install Google Authenticator or a similar app on your phone. Scan the QR code it shows you, then enter the 6-digit code to confirm.",
    authenticatorSaveBackupCodes:
      "Save these somewhere safe — you will need them if you lose your phone",
    authenticatorSetupComplete: "Continue to Login",
    or: "or",

    // Dashboard
    dashboard: "Dashboard",
    adminDashboard: "Admin Dashboard",
    employeeDashboard: "Employee Dashboard",
    myPayslips: "My Payslips",
    publications: "Publications",
    users: "Users",
    polls: "Polls & Surveys",

    // Payslips
    payslip: "Payslip",
    payslips: "Payslips",
    noPayslips: "No payslips available",
    totalPayslips: "Total Payslips",
    latestPayslip: "Latest Payslip",
    downloadPayslip: "Download Payslip",
    uploadPayslip: "Upload Payslip",
    month: "Month",
    year: "Year",
    uploadedAt: "Uploaded At",

    // Users
    addUser: "Add User",
    editUser: "Edit User",
    deleteUser: "Delete User",
    fullName: "Full Name",
    role: "Role",
    admin: "Admin",
    employee: "Employee",
    createdAt: "Created",

    // Months
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",

    // Messages
    loginSuccess: "Login successful",
    loginFailed: "Login failed. Please try again.",
    passwordChanged: "Password changed successfully",
    twoFAEnabledSuccess:
      "2FA enabled successfully! Make sure you saved your backup codes.",
    twoFADisabledSuccess:
      "2FA has been disabled. Your account is now less secure.",
    invalidCredentials: "Invalid credentials",
    invalidCode: "Invalid code",

    // Settings
    settings: "Settings",
    language: "Language",

    // Polls
    pollsManagement: "Polls Management",
    pollsManagementSubtitle: "Create and manage employee polls",
    createPoll: "Create Poll",
    createNewPoll: "Create New Poll",
    pollResults: "Poll Results",
    pollTitle: "Poll Title",
    pollDescription: "Description",
    pollOptions: "Options",
    pollClosesAt: "Closes At (Optional)",
    allowMultipleChoice: "Allow multiple choice",
    addOption: "Add Option",
    captionOptional: "Caption (optional)",
    clickToAddPhoto: "Click to add photo",
    changePhoto: "Change photo",
    removePhoto: "Remove",
    creating: "Creating...",
    exporting: "Exporting...",
    exportToExcel: "Export to Excel",
    totalVotes: "Total votes",
    votes: "votes",
    noActivePollsTitle: "No active polls",
    noActivePollsDesc:
      "There are currently no polls available. Check back later!",
    noPollsYet: "No Polls Yet",
    noPollsYetDesc: "Create your first poll!",
    voted: "Voted",
    submitVote: "Submit Vote",
    submitting: "Submitting...",
    thanksForVoting: "Thanks for voting!",
    collapse: "Collapse",
    changeVote: "Change Vote",
    updateVote: "Update Vote",
    changingVote: "You are changing your vote. Select a new option below.",

    // Form 106
    form106Tab: "Form 106",
    form106Title: "Form 106",
    form106AdminDesc: "Manage annual Form 106 tax documents for employees.",
    uploadForm106: "Upload Form 106",
    form106UploadTitle: "Batch Form 106 Upload",
    form106UploadDesc:
      "Upload a multi-page PDF where each page is a Form 106 for one employee. The system will detect the employee number (מספר העובד) on each page.",
    noForm106Available: "No Form 106 documents available",
    noForm106Message:
      "Your Form 106 documents will appear here once uploaded by HR.",
    noForm106Yet: "No Form 106 documents uploaded yet.",
    totalForm106: "Total Form 106 Documents",
    failedToLoad: "Failed to load",
    downloadFailed: "Download failed",
    deleteFailed: "Delete failed",
    confirmDelete: "Are you sure you want to delete this record?",
    form106SetupTitle: "Configure Form 106 Extraction",
    form106SetupBtn: "Configure",
    form106NotConfigured: "Not configured",
    form106SetupStep1Title: "Upload a sample Form 106",
    form106SetupStep1Desc:
      "Upload any Form 106 PDF. We will render the first page so you can click on the employee number.",
    form106SetupRendering: "Rendering PDF preview...",
    form106SetupChooseFile: "Choose PDF File",
    form106SetupStep2Title: "Click on the employee number",
    form106SetupStep2Desc:
      "Click directly on the employee number in the document. The system will snap to the nearest number.",
    form106SetupStep2Tip:
      "💡 Tip: click on the digits themselves, not on the label next to them.",
    form106SetupSelected: "Selected",
    form106SetupClickSave: "click Save to confirm",
    form106SetupSaveBtn: "Save Configuration",
    form106SetupSaved: "Configuration saved!",
    form106SetupSavedDesc:
      "Future Form 106 uploads will use this position to find the employee number on each page.",
    saving: "Saving...",

    // Audit log
    logsTab: "Logs",
    logsTitle: "Security Logs",
    logsSubtitle: "Login activity, failed attempts and security alerts",
    logsSummaryTotal: "Total Events",
    logsSummaryAlerts: "Alerts",
    logsSummaryWarnings: "Warnings",
    logsSummaryFailed24h: "Failed Logins (24h)",
    logsSummarySuspicious: "Suspicious Activity",
    logsLevelAll: "All Levels",
    logsLevelInfo: "Info",
    logsLevelWarn: "Warning",
    logsLevelAlert: "Alert",
    logsEventAll: "All Events",
    logsSearch: "Search user, IP, details...",
    logsColTime: "Time",
    logsColLevel: "Level",
    logsColEvent: "Event",
    logsColUser: "User",
    logsColIp: "IP",
    logsColDetails: "Details",
    logsNoEntries: "No log entries found",
    logsLoadMore: "Load More",
    logsRefresh: "Refresh",
    logsEventLoginSuccess: "Login",
    logsEventLoginFailed: "Failed Login",
    logsEvent2faFailed: "2FA Failed",
    logsEvent2faSuccess: "2FA Success",
    logsEventUnauthorized: "Unauthorized Access",
    logsEventSuspicious: "Suspicious Activity",
    logsEventPasswordChanged: "Password Changed",
    logsEventAdminAction: "Admin Action",
    logsEventBatchUpload: "Batch Upload",
    logsEventBulkDelete: "Bulk Delete",

    leading: "Leading",
    yourChoice: "Your choice",
    multipleChoiceHint: "You can select multiple options",
    pollTitle_label: "Title",
    pollStatus: "Status",
    pollType: "Type",
    pollCloses: "Closes",
    multiChoice: "Multi-choice",
    multi: "Multi",
    activate: "Activate",
    closePoll: "Close Poll",
    results: "Results",
    pollCreated: "Poll created successfully!",
    pollDeleted: "Poll deleted successfully!",
    pollActivated: "Poll activated successfully!",
    pollClosed: "Poll closed successfully!",
    confirmDeletePoll: "Are you sure you want to delete this poll?",
    optionsHint: "2–10, each needs an image or caption",
    pleaseSelectOption: "Please select at least one option",
    voteRecorded: "Vote recorded successfully!",
    employeesHaveVoted: "employees have voted",
    employeeHasVoted: "employee has voted",

    // Batch Upload & Mass Delete Modals
    batchUploadPayslips: "Batch Upload Payslips",
    multiPagePDFUpload: "Multi-Page PDF Upload",
    multiPagePDFDesc:
      "Upload a single PDF containing multiple payslips (one per page). The system will extract the employee number from each page automatically. Large files may take a few minutes — you'll see live progress.",
    selectMonth: "Select month...",
    multiPagePDFFile: "Multi-Page PDF File",
    uploadBatch: "Upload Batch",
    uploadingFile: "Uploading file…",
    sendingFile: "Sending file to the server. Please wait.",
    processingPages: "Processing pages…",
    extractingPages: "Extracting pages and matching employees…",
    pageOf: "Page",
    processingBackground:
      "You can close this modal — processing will continue in the background. The publications list will update automatically when done.",
    successfulPages: "successful",
    failedPages: "failed",
    outOf: "out of",
    pages: "pages",
    failedPagesList: "Failed pages:",
    uploadFailed: "Upload failed",
    tryAgain: "Try Again",
    closeProcessing: "Close (processing continues in background)",
    massDeleteUsers: "Mass Delete Users",
    massDeleteDesc:
      "Enter employee numbers separated by spaces, commas, or newlines. You can also paste directly from Excel — rows and columns both work.",
    employeeNumbers: "Employee Numbers",
    massDeletePastePlaceholder: `Paste from Excel or type manually:
1001 1002 1003
or
1001, 1002, 1003`,
    employeesRecognized: "employees recognized",
    employeeRecognized: "employee recognized",
    clearAll: "Clear all",
    massDeleteConfirm: "I understand this will permanently delete",
    userAccount: "user account",
    userAccounts: "user accounts",
    andCannotBeUndone: "and cannot be undone.",
    deleteUsers: "Delete",
    notFound: "Not found",

    // Poll edit / phase 2
    editPoll: "Edit Poll",
    pollDetails: "Poll Details",
    editOptionsNote:
      "Changing options will replace all existing options. Votes already cast will be preserved.",
    saveChanges: "Save Changes",
    pollUpdated: "Poll updated successfully!",
    reactivate: "Reactivate",
    addPhase2: "Add Phase 2",
    hasPhase2: "Has Phase 2",
    createPhase2: "Create Phase 2",
    phase2Label: "Phase 2",
    phase2Desc:
      "Phase 2 is a follow-up poll shown only to employees who voted specific options in the parent poll.",
    phase2TriggerLabel: "Show phase 2 to employees who voted for:",
    phase2TriggerDesc:
      "Select which answer(s) in the parent poll should trigger this follow-up.",
    phase2TriggersSelected: "trigger option(s) selected",
    phase2PollConfig: "Phase 2 Poll Configuration",
    phase2Created: "Phase 2 poll created successfully!",
    phase2FollowUp: "Follow-up question",
    untitled: "Untitled",
    noCaption: "No caption",

    notificationsEnabled:
      "Notifications enabled! You'll be notified about new payslips and polls.",
    notificationsDisabled: "Notifications disabled.",
    notificationsBlocked:
      "Notifications are blocked. Please enable them in your browser settings.",
    notificationsOn: "Notifications on",
    notificationsOff: "Enable notifications",
    selectLanguage: "Select Language",

    // Admin Dashboard
    adminDashboardSubtitle: "Manage users and payslip publications",
    securityNotice: "Security Notice",
    securityNoticeText: "You can download your own payslips from the",
    securityNoticeText2:
      "tab. For privacy and security, you cannot download other employees' payslips.",
    myPayslipsPersonal:
      "These are your personal payslips that you can download.",
    noPayslipsYet: "You don't have any payslips yet",
    noPublicationsYet: "No publications yet.",
    payslipPublications: "Payslip Publications",
    managePublications: "Manage batch uploads by month/year",
    manageUsers: "Manage Users",
    massDelete: "Mass Delete",
    batchUpload: "Batch Upload",
    addNewUser: "Add New User",
    editUserTitle: "Edit User",
    viewDetails: "View Details",
    uploaded: "Uploaded",
    totalPages: "Total Pages",
    successful: "Successful",
    failed: "Failed",
    deleting: "Deleting...",
    uploading: "Uploading...",
    allRoles: "All Roles",
    sortById: "Sort by ID",
    sortByName: "Sort by Name",
    sortByEmail: "Sort by Email",
    sortByRole: "Sort by Role",
    sortByDate: "Sort by Date",
    clearFilters: "Clear Filters",
    showing: "Showing",
    of: "of",
    itemsPerPage: "Items per page",
    noUsersYet: "No users yet",
    noUsersMatch: "No users match your filters",
    joined: "Joined",
    publicationDetails: "Publication Details",
    batchUploadEmployees: "Batch Upload Employees",
    batchUploadResults: "Batch Upload Results",
    uploadComplete: "Upload Complete",
    uploadEmployees: "Upload Employees",
    pageLabel: "Page",
    employeeIdUnique: "Must be unique",
    emailOptional: "Email (Optional)",
    leaveEmptyEmail: "Leave empty if not needed",
    passwordMinChars: "Minimum 6 characters",
    changeEmployeeId: "Change employee ID (must be unique)",
    newPasswordOptional: "New Password (Optional)",
    leaveEmptyPassword: "Leave empty to keep current",
    welcomeEmployee: "Welcome",
    viewDownloadPayslips: "View and download your payslips",
    noPayslipsAvailable: "No Payslips Available",
    noPayslipsMessage:
      "You don't have any payslips yet. They will appear here when uploaded by HR.",
    enableNotifications: "Enable Notifications",
    notificationsDesc:
      "Get instant alerts when new payslips or polls are available",
    enable: "Enable",
    monthLabel: "Month",
    fileName: "File Name",
    uploadDate: "Upload Date",
    actions: "Actions",
    downloadPDF: "Download PDF",
    confirmNewPassword: "Confirm New Password",
    passwordsDoNotMatch: "New passwords do not match",
    passwordTooShort: "New password must be at least 6 characters",
    passwordChangedSuccess: "Password changed successfully!",
    searchPlaceholder: "Search by name, ID, or email...",
    initialPassword: "Initial Password",
    worklogTab: "Work Log",
    documentsTab: "Documents",
    uploadAndView: "Upload & View",
    myForm106Tab: "My Form 106",
    myWorklogTab: "My Work Log",
    worklogTitle: "Work Log",
    worklogAdminDesc: "Manage monthly work log documents for employees.",
    uploadWorklog: "Upload Work Log",
    worklogUploadTitle: "Batch Work Log Upload",
    worklogUploadDesc:
      "Upload a multi-page PDF where each page is a work log for one employee. The system will detect the employee number on each page.",
    noWorklogYet: "No work log documents uploaded yet.",
    noWorklogAvailable: "No work log documents available",
    noWorklogMessage:
      "Your work log documents will appear here once uploaded by HR.",
    worklogPeriodAutoDetected:
      "The month and year are detected automatically from the PDF.",
    resetPassword: "Reset Password",
    autoPasswordInfo:
      "A secure random password (letters and numbers) will be generated automatically. The employee must change it on first login. View it in the users table.",
    reset2FA: "Reset 2FA",
    resetAuthenticator: "Reset Authenticator",
    mustChangePasswordDesc:
      "For security, please choose a new password. It must be at least 6 characters long and include at least 2 of the following: an uppercase letter (A-Z), a lowercase letter (a-z), a number (0-9), or a special character (!@#...).",
    passwordStrengthWeak: "Weak",
    passwordComplexityHint:
      "Must be at least 6 characters and include at least 2 of: uppercase letter, lowercase letter, number, special character (!@#...)",
    passwordStrengthFair: "Fair",
    passwordStrengthGood: "Good",
    passwordStrengthStrong: "Strong",
    passwordCheckLength: "At least 6 characters",
    passwordCheckUppercase: "Uppercase (A-Z)",
    passwordCheckLowercase: "Lowercase (a-z)",
    passwordCheckDigit: "Number (0-9)",
    passwordCheckSpecial: "Special (!@#$...)",
  },

  he: {
    // Common
    welcome: "ברוך הבא",
    loading: "טוען...",
    save: "שמור",
    cancel: "ביטול",
    delete: "מחק",
    edit: "ערוך",
    close: "סגור",
    back: "חזור",
    next: "הבא",
    submit: "שלח",
    download: "הורד",
    upload: "העלה",
    search: "חפש",
    filter: "סנן",
    yes: "כן",
    no: "לא",

    // Authentication
    signIn: "התחבר",
    signOut: "התנתק",
    email: "דוא״ל",
    password: "סיסמה",
    employeeId: "מספר עובד",
    employeeIdOrEmail: "מספר עובד או דוא״ל",
    currentPassword: "סיסמה נוכחית",
    newPassword: "סיסמה חדשה",
    confirmPassword: "אמת סיסמה",
    changePassword: "שנה סיסמה",
    sessionExpired: "פג תוקף החיבור שלך. אנא התחבר מחדש.",
    forgotPassword: "לשחזור סיסמה - שלח וואטסאפ למטע: 050-585-6068",

    // 2FA
    twoFactorAuth: "אימות דו-שלבי",
    enable2FA: "הפעל אימות דו-שלבי",
    disable2FA: "בטל אימות דו-שלבי",
    twoFAEnabled: "אימות דו-שלבי פעיל",
    twoFARequired: "נדרש אימות דו-שלבי",
    enterCode: "הזן את הקוד מאפליקציית האימות",
    backupCode: "קוד גיבוי",
    useBackupCode: "השתמש בקוד גיבוי",
    useAuthenticatorCode: "השתמש בקוד אימות",
    scanQRCode: "סרוק QR",
    setupTwoFA: "הגדר אימות דו-שלבי",
    disable2FAWarning:
      "ביטול אימות דו-שלבי יהפוך את החשבון שלך לפחות מאובטח. תצטרך רק סיסמה כדי להתחבר.",
    confirmPassword2FA: "אשר את הסיסמה שלך",

    // Authenticator mode
    authenticatorModeHint: "הכנס את מספר העובד שלך כדי להמשיך",
    authenticatorSetupRequired: "עליך להגדיר אפליקציית אימות לפני שתוכל להתחבר",
    authenticatorSetupDesc:
      "התקן את Google Authenticator או אפליקציה דומה בטלפון שלך. סרוק את קוד ה-QR והזן את הקוד בן 6 הספרות לאישור.",
    authenticatorSaveBackupCodes:
      "שמור את הקודים האלה במקום בטוח — תזדקק להם אם תאבד את הטלפון",
    authenticatorSetupComplete: "המשך להתחברות",
    or: "או",

    // Dashboard
    dashboard: "לוח בקרה",
    adminDashboard: "לוח בקרה מנהל",
    employeeDashboard: "לוח בקרה עובד",
    myPayslips: "תלושי השכר שלי",
    publications: "פרסומים",
    users: "משתמשים",
    polls: "סקרים והצבעות",

    // Payslips
    payslip: "תלוש שכר",
    payslips: "תלושי שכר",
    noPayslips: "אין תלושי שכר זמינים",
    totalPayslips: "סה״כ תלושים",
    latestPayslip: "תלוש אחרון",
    downloadPayslip: "הורד תלוש",
    uploadPayslip: "העלה תלוש",
    month: "חודש",
    year: "שנה",
    uploadedAt: "הועלה ב",

    // Users
    addUser: "הוסף משתמש",
    editUser: "ערוך משתמש",
    deleteUser: "מחק משתמש",
    fullName: "שם מלא",
    role: "תפקיד",
    admin: "מנהל",
    employee: "עובד",
    createdAt: "נוצר",

    // Months
    january: "ינואר",
    february: "פברואר",
    march: "מרץ",
    april: "אפריל",
    may: "מאי",
    june: "יוני",
    july: "יולי",
    august: "אוגוסט",
    september: "ספטמבר",
    october: "אוקטובר",
    november: "נובמבר",
    december: "דצמבר",

    // Messages
    loginSuccess: "התחברת בהצלחה",
    loginFailed: "ההתחברות נכשלה. נסה שוב.",
    passwordChanged: "הסיסמה שונתה בהצלחה",
    twoFAEnabledSuccess:
      "אימות דו-שלבי הופעל בהצלחה! וודא ששמרת את קודי הגיבוי.",
    twoFADisabledSuccess: "אימות דו-שלבי בוטל. החשבון שלך כעת פחות מאובטח.",
    invalidCredentials: "פרטי התחברות שגויים",
    invalidCode: "קוד שגוי",

    // Settings
    settings: "הגדרות",
    language: "שפה",

    // Polls
    pollsManagement: "ניהול סקרים",
    pollsManagementSubtitle: "צור ונהל סקרי עובדים",
    createPoll: "צור סקר",
    createNewPoll: "צור סקר חדש",
    pollResults: "תוצאות הסקר",
    pollTitle: "כותרת הסקר",
    pollDescription: "תיאור",
    pollOptions: "אפשרויות",
    pollClosesAt: "נסגר ב (אופציונלי)",
    allowMultipleChoice: "אפשר בחירה מרובה",
    addOption: "הוסף אפשרות",
    captionOptional: "כיתוב (אופציונלי)",
    clickToAddPhoto: "לחץ להוספת תמונה",
    changePhoto: "שנה תמונה",
    removePhoto: "הסר",
    creating: "יוצר...",
    exporting: "מייצא...",
    exportToExcel: "ייצא ל-Excel",
    totalVotes: "סה״כ הצבעות",
    votes: "הצבעות",
    noActivePollsTitle: "אין סקרים פעילים",
    noActivePollsDesc: "אין סקרים זמינים כרגע. בדוק שוב מאוחר יותר!",
    noPollsYet: "אין סקרים עדיין",
    noPollsYetDesc: "צור את הסקר הראשון שלך!",
    voted: "הצבעת",
    submitVote: "שלח הצבעה",
    submitting: "שולח...",
    thanksForVoting: "תודה שהצבעת!",
    collapse: "כווץ",
    changeVote: "שנה הצבעה",
    updateVote: "עדכן הצבעה",
    changingVote: "אתה משנה את הצבעתך. בחר אפשרות חדשה למטה.",

    // Form 106
    form106Tab: "טופס 106",
    form106Title: "טופס 106",
    form106AdminDesc: "ניהול טפסי 106 שנתיים לעובדים.",
    uploadForm106: "העלאת טופס 106",
    form106UploadTitle: "העלאה קבוצתית של טופס 106",
    form106UploadDesc:
      "העלה PDF מרובה עמודים שבו כל עמוד הוא טופס 106 לעובד אחד. המערכת תזהה את מספר העובד בכל עמוד.",
    noForm106Available: "אין טפסי 106 זמינים",
    noForm106Message: "טפסי 106 שלך יופיעו כאן לאחר שיועלו על ידי משאבי אנוש.",
    noForm106Yet: "טרם הועלו טפסי 106.",
    totalForm106: 'סה"כ טפסי 106',
    failedToLoad: "הטעינה נכשלה",
    downloadFailed: "ההורדה נכשלה",
    deleteFailed: "המחיקה נכשלה",
    confirmDelete: "האם אתה בטוח שברצונך למחוק רשומה זו?",
    form106SetupTitle: "הגדרת חילוץ טופס 106",
    form106SetupBtn: "הגדרה",
    form106NotConfigured: "לא מוגדר",
    form106SetupStep1Title: "העלה דוגמת טופס 106",
    form106SetupStep1Desc:
      "העלה קובץ PDF של טופס 106. נציג את העמוד הראשון ותוכל ללחוץ על מספר העובד.",
    form106SetupRendering: "מרנדר תצוגה מקדימה...",
    form106SetupChooseFile: "בחר קובץ PDF",
    form106SetupStep2Title: "לחץ על מספר העובד",
    form106SetupStep2Desc:
      "לחץ ישירות על מספר העובד במסמך. המערכת תינעל על המספר הקרוב ביותר.",
    form106SetupStep2Tip: "💡 טיפ: לחץ על הספרות עצמן, לא על התווית שלידן.",
    form106SetupSelected: "נבחר",
    form106SetupClickSave: "לחץ שמור לאישור",
    form106SetupSaveBtn: "שמור הגדרות",
    form106SetupSaved: "ההגדרות נשמרו!",
    form106SetupSavedDesc:
      "העלאות עתידיות ישתמשו במיקום זה לאיתור מספר העובד בכל עמוד.",
    saving: "שומר...",

    // Audit log
    logsTab: "לוגים",
    logsTitle: "לוגים ואבטחה",
    logsSubtitle: "פעילות התחברות, ניסיונות כושלים והתראות אבטחה",
    logsSummaryTotal: 'סה"כ אירועים',
    logsSummaryAlerts: "התראות",
    logsSummaryWarnings: "אזהרות",
    logsSummaryFailed24h: "כניסות כושלות (24 שעות)",
    logsSummarySuspicious: "פעילות חשודה",
    logsLevelAll: "כל הרמות",
    logsLevelInfo: "מידע",
    logsLevelWarn: "אזהרה",
    logsLevelAlert: "התראה",
    logsEventAll: "כל האירועים",
    logsSearch: "חיפוש משתמש, IP, פרטים...",
    logsColTime: "זמן",
    logsColLevel: "רמה",
    logsColEvent: "אירוע",
    logsColUser: "משתמש",
    logsColIp: "IP",
    logsColDetails: "פרטים",
    logsNoEntries: "לא נמצאו רשומות",
    logsLoadMore: "טען עוד",
    logsRefresh: "רענן",
    logsEventLoginSuccess: "כניסה",
    logsEventLoginFailed: "כניסה כושלת",
    logsEvent2faFailed: "כשל 2FA",
    logsEvent2faSuccess: "אימות 2FA",
    logsEventUnauthorized: "גישה לא מורשית",
    logsEventSuspicious: "פעילות חשודה",
    logsEventPasswordChanged: "שינוי סיסמה",
    logsEventAdminAction: "פעולת מנהל",
    logsEventBatchUpload: "העלאה קבוצתית",
    logsEventBulkDelete: "מחיקה קבוצתית",

    leading: "מוביל",
    yourChoice: "הבחירה שלך",
    multipleChoiceHint: "ניתן לבחור מספר אפשרויות",
    pollTitle_label: "כותרת",
    pollStatus: "סטטוס",
    pollType: "סוג",
    pollCloses: "נסגר",
    multiChoice: "בחירה מרובה",
    multi: "מרובה",
    activate: "הפעל",
    closePoll: "סגור סקר",
    results: "תוצאות",
    pollCreated: "הסקר נוצר בהצלחה!",
    pollDeleted: "הסקר נמחק בהצלחה!",
    pollActivated: "הסקר הופעל בהצלחה!",
    pollClosed: "הסקר נסגר בהצלחה!",
    confirmDeletePoll: "האם אתה בטוח שברצונך למחוק את הסקר?",
    optionsHint: "2–10, כל אחת צריכה תמונה או כיתוב",
    pleaseSelectOption: "אנא בחר לפחות אפשרות אחת",
    voteRecorded: "ההצבעה נרשמה בהצלחה!",
    employeesHaveVoted: "עובדים הצביעו",
    employeeHasVoted: "עובד הצביע",

    // Batch Upload & Mass Delete Modals
    batchUploadPayslips: "העלאת תלושים בקבוצה",
    multiPagePDFUpload: "העלאת PDF רב-עמודי",
    multiPagePDFDesc:
      "העלה PDF אחד המכיל מספר תלושי שכר (עמוד אחד לכל תלוש). המערכת תחלץ את מספר העובד מכל עמוד אוטומטית. קבצים גדולים עשויים לקחת מספר דקות — תראה התקדמות בזמן אמת.",
    selectMonth: "בחר חודש...",
    multiPagePDFFile: "קובץ PDF רב-עמודי",
    uploadBatch: "העלה קבוצה",
    uploadingFile: "מעלה קובץ…",
    sendingFile: "שולח קובץ לשרת. אנא המתן.",
    processingPages: "מעבד עמודים…",
    extractingPages: "מחלץ עמודים ומתאים עובדים…",
    pageOf: "עמוד",
    processingBackground:
      "ניתן לסגור חלון זה — העיבוד ימשיך ברקע. רשימת הפרסומים תתעדכן אוטומטית בסיום.",
    successfulPages: "הצליחו",
    failedPages: "נכשלו",
    outOf: "מתוך",
    pages: "עמודים",
    failedPagesList: "עמודים שנכשלו:",
    uploadFailed: "ההעלאה נכשלה",
    tryAgain: "נסה שוב",
    closeProcessing: "סגור (העיבוד ממשיך ברקע)",
    massDeleteUsers: "מחיקה המונית של משתמשים",
    massDeleteDesc:
      "הזן מספרי עובדים מופרדים ברווחים, פסיקים או שורות חדשות. ניתן גם להדביק ישירות מ-Excel.",
    employeeNumbers: "מספרי עובדים",
    massDeletePastePlaceholder: `הדבק מ-Excel או הקלד ידנית:
1001 1002 1003
או
1001, 1002, 1003`,
    employeesRecognized: "עובדים זוהו",
    employeeRecognized: "עובד זוהה",
    clearAll: "נקה הכול",
    massDeleteConfirm: "אני מבין שפעולה זו תמחק לצמיתות",
    userAccount: "חשבון משתמש",
    userAccounts: "חשבונות משתמש",
    andCannotBeUndone: "ולא ניתן לבטלה.",
    deleteUsers: "מחק",
    notFound: "לא נמצא",

    // Poll edit / phase 2
    editPoll: "ערוך סקר",
    pollDetails: "פרטי הסקר",
    editOptionsNote:
      "שינוי האפשרויות יחליף את כל האפשרויות הקיימות. הצבעות שכבר נרשמו יישמרו.",
    saveChanges: "שמור שינויים",
    pollUpdated: "הסקר עודכן בהצלחה!",
    reactivate: "הפעל מחדש",
    addPhase2: "הוסף שלב 2",
    hasPhase2: "יש שלב 2",
    createPhase2: "צור שלב 2",
    phase2Label: "שלב 2",
    phase2Desc:
      "שלב 2 הוא סקר המשך שמוצג רק לעובדים שהצביעו לאפשרויות מסוימות בסקר הראשי.",
    phase2TriggerLabel: "הצג שלב 2 לעובדים שהצביעו עבור:",
    phase2TriggerDesc: "בחר אילו תשובות בסקר הראשי יפעילו את שאלת ההמשך.",
    phase2TriggersSelected: "אפשרות(ות) הפעלה נבחרו",
    phase2PollConfig: "הגדרות סקר שלב 2",
    phase2Created: "סקר שלב 2 נוצר בהצלחה!",
    phase2FollowUp: "שאלת המשך",
    untitled: "ללא כותרת",
    noCaption: "ללא כיתוב",

    notificationsEnabled: "התראות הופעלו! תקבל התראות על תלושים חדשים וסקרים.",
    notificationsDisabled: "התראות בוטלו.",
    notificationsBlocked: "התראות חסומות. אנא הפעל אותן בהגדרות הדפדפן.",
    notificationsOn: "התראות פועלות",
    notificationsOff: "הפעל התראות",
    selectLanguage: "בחר שפה",

    // Admin Dashboard
    adminDashboardSubtitle: "ניהול משתמשים ותלושי שכר",
    securityNotice: "הודעת אבטחה",
    securityNoticeText: "ניתן להוריד את תלושי השכר שלך מהכרטיסייה",
    securityNoticeText2:
      "מטעמי פרטיות ואבטחה, לא ניתן להוריד תלושי שכר של עובדים אחרים.",
    myPayslipsPersonal: "אלו תלושי השכר האישיים שלך שניתן להוריד.",
    noPayslipsYet: "אין לך תלושי שכר עדיין",
    noPublicationsYet: "אין פרסומים עדיין.",
    payslipPublications: "פרסומי תלושי שכר",
    managePublications: "ניהול העלאות קבוצתיות לפי חודש/שנה",
    manageUsers: "ניהול משתמשים",
    massDelete: "מחיקה קבוצתית",
    batchUpload: "העלאה קבוצתית",
    addNewUser: "הוסף משתמש חדש",
    editUserTitle: "ערוך משתמש",
    viewDetails: "הצג פרטים",
    uploaded: "הועלה",
    totalPages: "סה״כ עמודים",
    successful: "הצליח",
    failed: "נכשל",
    deleting: "מוחק...",
    uploading: "מעלה...",
    allRoles: "כל התפקידים",
    sortById: "מיין לפי מזהה",
    sortByName: "מיין לפי שם",
    sortByEmail: "מיין לפי דוא״ל",
    sortByRole: "מיין לפי תפקיד",
    sortByDate: "מיין לפי תאריך",
    clearFilters: "נקה סינון",
    showing: "מציג",
    of: "מתוך",
    itemsPerPage: "פריטים לעמוד",
    noUsersYet: "אין משתמשים עדיין",
    noUsersMatch: "אין משתמשים התואמים לסינון",
    joined: "הצטרף",
    publicationDetails: "פרטי פרסום",
    batchUploadEmployees: "העלאה קבוצתית של עובדים",
    batchUploadResults: "תוצאות העלאה קבוצתית",
    uploadComplete: "העלאה הושלמה",
    uploadEmployees: "העלה עובדים",
    pageLabel: "עמוד",
    employeeIdUnique: "חייב להיות ייחודי",
    emailOptional: "דוא״ל (אופציונלי)",
    leaveEmptyEmail: "השאר ריק אם לא נדרש",
    passwordMinChars: "מינימום 6 תווים",
    changeEmployeeId: "שנה מספר עובד (חייב להיות ייחודי)",
    newPasswordOptional: "סיסמה חדשה (אופציונלי)",
    leaveEmptyPassword: "השאר ריק לשמור סיסמה נוכחית",
    welcomeEmployee: "ברוך הבא",
    viewDownloadPayslips: "הצג והורד את תלושי השכר שלך",
    noPayslipsAvailable: "אין תלושי שכר זמינים",
    noPayslipsMessage:
      "אין לך תלושי שכר עדיין. הם יופיעו כאן לאחר העלאה על ידי מחלקת משאבי אנוש.",
    enableNotifications: "הפעל התראות",
    notificationsDesc:
      "קבל התראות מיידיות כאשר מועלים תלושי שכר חדשים או סקרים",
    enable: "הפעל",
    monthLabel: "חודש",
    fileName: "שם קובץ",
    uploadDate: "תאריך העלאה",
    actions: "פעולות",
    downloadPDF: "הורד PDF",
    confirmNewPassword: "אמת סיסמה חדשה",
    passwordsDoNotMatch: "הסיסמאות החדשות אינן תואמות",
    passwordTooShort: "הסיסמה החדשה חייבת להכיל לפחות 6 תווים",
    passwordChangedSuccess: "הסיסמה שונתה בהצלחה!",
    searchPlaceholder: "חפש לפי שם, מזהה, או דוא״ל...",
    initialPassword: "סיסמה ראשונית",
    worklogTab: "יומן עבודה",
    documentsTab: "מסמכים",
    uploadAndView: "העלאה וצפייה",
    myForm106Tab: "טופס 106 שלי",
    myWorklogTab: "יומן עבודה שלי",
    worklogTitle: "יומן עבודה",
    worklogAdminDesc: "ניהול יומני עבודה חודשיים לעובדים.",
    uploadWorklog: "העלאת יומן עבודה",
    worklogUploadTitle: "העלאה קבוצתית של יומני עבודה",
    worklogUploadDesc:
      "העלה PDF מרובה עמודים שבו כל עמוד הוא יומן עבודה לעובד אחד. המערכת תזהה את מספר העובד בכל עמוד.",
    noWorklogYet: "טרם הועלו יומני עבודה.",
    noWorklogAvailable: "אין יומני עבודה זמינים",
    noWorklogMessage:
      "יומני העבודה שלך יופיעו כאן לאחר שיועלו על ידי משאבי אנוש.",
    worklogPeriodAutoDetected: "החודש והשנה מזוהים אוטומטית מה-PDF.",
    resetPassword: "אפס סיסמה",
    autoPasswordInfo:
      "סיסמה אקראית (אותיות ומספרים) תיווצר אוטומטית. העובד חייב לשנות אותה בכניסה הראשונה. ניתן לצפות בה בטבלת המשתמשים.",
    reset2FA: "אפס 2FA",
    resetAuthenticator: "אפס אימות",
    mustChangePasswordDesc:
      "מטעמי אבטחה, אנא בחר סיסמה חדשה. עליה להכיל לפחות 6 תווים ולפחות 2 מהבאים: אות גדולה (A-Z), אות קטנה (a-z), מספר (0-9), או תו מיוחד (!@#...).",
    passwordStrengthWeak: "חלשה",
    passwordComplexityHint:
      "לפחות 6 תווים ו-2 מתוך: אות גדולה, אות קטנה, מספר, תו מיוחד (!@#...)",
    passwordStrengthFair: "בינונית",
    passwordStrengthGood: "טובה",
    passwordStrengthStrong: "חזקה",
    passwordCheckLength: "לפחות 6 תווים",
    passwordCheckUppercase: "אות גדולה (A-Z)",
    passwordCheckLowercase: "אות קטנה (a-z)",
    passwordCheckDigit: "ספרה (0-9)",
    passwordCheckSpecial: "תו מיוחד (!@#$...)",
  },

  ru: {
    // Common
    welcome: "Добро пожаловать",
    loading: "Загрузка...",
    save: "Сохранить",
    cancel: "Отмена",
    delete: "Удалить",
    edit: "Редактировать",
    close: "Закрыть",
    back: "Назад",
    next: "Далее",
    submit: "Отправить",
    download: "Скачать",
    upload: "Загрузить",
    search: "Поиск",
    filter: "Фильтр",
    yes: "Да",
    no: "Нет",

    // Authentication
    signIn: "Войти",
    signOut: "Выйти",
    email: "Эл. почта",
    password: "Пароль",
    employeeId: "ID сотрудника",
    employeeIdOrEmail: "ID сотрудника или эл. почта",
    currentPassword: "Текущий пароль",
    newPassword: "Новый пароль",
    confirmPassword: "Подтвердите пароль",
    changePassword: "Изменить пароль",
    sessionExpired: "Срок сеанса истёк. Пожалуйста, войдите снова.",
    forgotPassword:
      "Для сброса пароля — напишите в WhatsApp в Mata: 050-585-6068",

    // 2FA
    twoFactorAuth: "Двухфакторная аутентификация",
    enable2FA: "Включить 2FA",
    disable2FA: "Отключить 2FA",
    twoFAEnabled: "2FA включена",
    twoFARequired: "Требуется 2FA",
    enterCode: "Введите код из приложения аутентификации",
    backupCode: "Резервный код",
    useBackupCode: "Использовать резервный код",
    useAuthenticatorCode: "Использовать код аутентификации",
    scanQRCode: "Сканировать QR-код",
    setupTwoFA: "Настроить двухфакторную аутентификацию",
    disable2FAWarning:
      "Отключение 2FA сделает вашу учетную запись менее защищенной. Для входа потребуется только пароль.",
    confirmPassword2FA: "Подтвердите ваш пароль",

    // Authenticator mode
    authenticatorModeHint: "Введите ваш ID сотрудника для продолжения",
    authenticatorSetupRequired:
      "Перед входом необходимо настроить аутентификатор",
    authenticatorSetupDesc:
      "Установите Google Authenticator или аналогичное приложение. Отсканируйте QR-код и введите 6-значный код для подтверждения.",
    authenticatorSaveBackupCodes:
      "Сохраните эти коды в надёжном месте — они понадобятся при потере телефона",
    authenticatorSetupComplete: "Перейти к входу",
    or: "или",

    // Dashboard
    dashboard: "Панель управления",
    adminDashboard: "Панель администратора",
    employeeDashboard: "Панель сотрудника",
    myPayslips: "Мои расчетные листки",
    publications: "Публикации",
    users: "Пользователи",
    polls: "Опросы и голосования",

    // Payslips
    payslip: "Расчетный листок",
    payslips: "Расчетные листки",
    noPayslips: "Нет доступных расчетных листков",
    totalPayslips: "Всего листков",
    latestPayslip: "Последний листок",
    downloadPayslip: "Скачать листок",
    uploadPayslip: "Загрузить листок",
    month: "Месяц",
    year: "Год",
    uploadedAt: "Загружено",

    // Users
    addUser: "Добавить пользователя",
    editUser: "Редактировать пользователя",
    deleteUser: "Удалить пользователя",
    fullName: "Полное имя",
    role: "Роль",
    admin: "Администратор",
    employee: "Сотрудник",
    createdAt: "Создано",

    // Months
    january: "Январь",
    february: "Февраль",
    march: "Март",
    april: "Апрель",
    may: "Май",
    june: "Июнь",
    july: "Июль",
    august: "Август",
    september: "Сентябрь",
    october: "Октябрь",
    november: "Ноябрь",
    december: "Декабрь",

    // Messages
    loginSuccess: "Вход выполнен успешно",
    loginFailed: "Ошибка входа. Попробуйте снова.",
    passwordChanged: "Пароль успешно изменен",
    twoFAEnabledSuccess: "2FA успешно включена! Сохраните резервные коды.",
    twoFADisabledSuccess: "2FA отключена. Ваша учетная запись менее защищена.",
    invalidCredentials: "Неверные учетные данные",
    invalidCode: "Неверный код",

    // Settings
    settings: "Настройки",
    language: "Язык",

    // Polls
    pollsManagement: "Управление опросами",
    pollsManagementSubtitle: "Создание и управление опросами сотрудников",
    createPoll: "Создать опрос",
    createNewPoll: "Создать новый опрос",
    pollResults: "Результаты опроса",
    pollTitle: "Название опроса",
    pollDescription: "Описание",
    pollOptions: "Варианты",
    pollClosesAt: "Закрывается (необязательно)",
    allowMultipleChoice: "Разрешить несколько ответов",
    addOption: "Добавить вариант",
    captionOptional: "Подпись (необязательно)",
    clickToAddPhoto: "Нажмите, чтобы добавить фото",
    changePhoto: "Изменить фото",
    removePhoto: "Удалить",
    creating: "Создание...",
    exporting: "Экспорт...",
    exportToExcel: "Экспорт в Excel",
    totalVotes: "Всего голосов",
    votes: "голосов",
    noActivePollsTitle: "Нет активных опросов",
    noActivePollsDesc: "Опросов пока нет. Загляните позже!",
    noPollsYet: "Опросов пока нет",
    noPollsYetDesc: "Создайте свой первый опрос!",
    voted: "Проголосовал",
    submitVote: "Проголосовать",
    submitting: "Отправка...",
    thanksForVoting: "Спасибо за голос!",
    collapse: "Свернуть",
    changeVote: "Изменить голос",
    updateVote: "Обновить голос",
    changingVote: "Вы меняете свой голос. Выберите новый вариант ниже.",

    // Form 106
    form106Tab: "Форма 106",
    form106Title: "Форма 106",
    form106AdminDesc:
      "Управление годовыми документами формы 106 для сотрудников.",
    uploadForm106: "Загрузить форму 106",
    form106UploadTitle: "Пакетная загрузка формы 106",
    form106UploadDesc:
      "Загрузите многостраничный PDF, где каждая страница — форма 106 одного сотрудника. Система определит номер сотрудника на каждой странице.",
    noForm106Available: "Документы формы 106 недоступны",
    noForm106Message:
      "Ваши документы формы 106 появятся здесь после загрузки отделом кадров.",
    noForm106Yet: "Документы формы 106 ещё не загружены.",
    totalForm106: "Всего документов формы 106",
    failedToLoad: "Не удалось загрузить",
    downloadFailed: "Ошибка загрузки",
    deleteFailed: "Ошибка удаления",
    confirmDelete: "Вы уверены, что хотите удалить эту запись?",
    form106SetupTitle: "Настройка извлечения формы 106",
    form106SetupBtn: "Настроить",
    form106NotConfigured: "Не настроено",
    form106SetupStep1Title: "Загрузите образец формы 106",
    form106SetupStep1Desc:
      "Загрузите PDF формы 106. Мы отобразим первую страницу, чтобы вы могли нажать на номер сотрудника.",
    form106SetupRendering: "Рендеринг предпросмотра PDF...",
    form106SetupChooseFile: "Выбрать PDF файл",
    form106SetupStep2Title: "Нажмите на номер сотрудника",
    form106SetupStep2Desc:
      "Нажмите прямо на номер сотрудника в документе. Система привяжется к ближайшему числу.",
    form106SetupStep2Tip:
      "💡 Совет: нажимайте на сами цифры, а не на подпись рядом с ними.",
    form106SetupSelected: "Выбрано",
    form106SetupClickSave: "нажмите Сохранить для подтверждения",
    form106SetupSaveBtn: "Сохранить настройки",
    form106SetupSaved: "Настройки сохранены!",
    form106SetupSavedDesc:
      "Будущие загрузки формы 106 будут использовать эту позицию для поиска номера сотрудника.",
    saving: "Сохранение...",

    // Audit log
    logsTab: "Журнал",
    logsTitle: "Журнал безопасности",
    logsSubtitle: "Активность входа, неудачные попытки и предупреждения",
    logsSummaryTotal: "Всего событий",
    logsSummaryAlerts: "Оповещения",
    logsSummaryWarnings: "Предупреждения",
    logsSummaryFailed24h: "Неудачных входов (24ч)",
    logsSummarySuspicious: "Подозрительная активность",
    logsLevelAll: "Все уровни",
    logsLevelInfo: "Инфо",
    logsLevelWarn: "Предупреждение",
    logsLevelAlert: "Оповещение",
    logsEventAll: "Все события",
    logsSearch: "Поиск по пользователю, IP, деталям...",
    logsColTime: "Время",
    logsColLevel: "Уровень",
    logsColEvent: "Событие",
    logsColUser: "Пользователь",
    logsColIp: "IP",
    logsColDetails: "Детали",
    logsNoEntries: "Записи не найдены",
    logsLoadMore: "Загрузить ещё",
    logsRefresh: "Обновить",
    logsEventLoginSuccess: "Вход",
    logsEventLoginFailed: "Неудачный вход",
    logsEvent2faFailed: "Ошибка 2FA",
    logsEvent2faSuccess: "Успешная 2FA",
    logsEventUnauthorized: "Несанкционированный доступ",
    logsEventSuspicious: "Подозрительная активность",
    logsEventPasswordChanged: "Смена пароля",
    logsEventAdminAction: "Действие администратора",
    logsEventBatchUpload: "Пакетная загрузка",
    logsEventBulkDelete: "Массовое удаление",

    leading: "Лидирует",
    yourChoice: "Ваш выбор",
    multipleChoiceHint: "Можно выбрать несколько вариантов",
    pollTitle_label: "Название",
    pollStatus: "Статус",
    pollType: "Тип",
    pollCloses: "Закрывается",
    multiChoice: "Множественный выбор",
    multi: "Множественный",
    activate: "Активировать",
    closePoll: "Закрыть опрос",
    results: "Результаты",
    pollCreated: "Опрос успешно создан!",
    pollDeleted: "Опрос успешно удалён!",
    pollActivated: "Опрос успешно активирован!",
    pollClosed: "Опрос успешно закрыт!",
    confirmDeletePoll: "Вы уверены, что хотите удалить этот опрос?",
    optionsHint: "2–10, каждый вариант требует изображение или подпись",
    pleaseSelectOption: "Выберите хотя бы один вариант",
    voteRecorded: "Голос успешно зарегистрирован!",
    employeesHaveVoted: "сотрудников проголосовало",
    employeeHasVoted: "сотрудник проголосовал",

    // Batch Upload & Mass Delete Modals
    batchUploadPayslips: "Пакетная загрузка расчётных листов",
    multiPagePDFUpload: "Загрузка многостраничного PDF",
    multiPagePDFDesc:
      "Загрузите один PDF-файл, содержащий несколько расчётных листов (по одному на страницу). Система автоматически извлечёт номер сотрудника с каждой страницы.",
    selectMonth: "Выберите месяц...",
    multiPagePDFFile: "Многостраничный PDF-файл",
    uploadBatch: "Загрузить пакет",
    uploadingFile: "Загрузка файла…",
    sendingFile: "Отправка файла на сервер. Пожалуйста, подождите.",
    processingPages: "Обработка страниц…",
    extractingPages: "Извлечение страниц и сопоставление сотрудников…",
    pageOf: "Страница",
    processingBackground:
      "Вы можете закрыть это окно — обработка продолжится в фоне.",
    successfulPages: "успешно",
    failedPages: "с ошибкой",
    outOf: "из",
    pages: "страниц",
    failedPagesList: "Страницы с ошибками:",
    uploadFailed: "Ошибка загрузки",
    tryAgain: "Попробовать снова",
    closeProcessing: "Закрыть (обработка продолжается в фоне)",
    massDeleteUsers: "Массовое удаление пользователей",
    massDeleteDesc:
      "Введите номера сотрудников, разделённые пробелами, запятыми или переносами строк.",
    employeeNumbers: "Номера сотрудников",
    massDeletePastePlaceholder: `Вставьте из Excel или введите вручную:
1001 1002 1003
или
1001, 1002, 1003`,
    employeesRecognized: "сотрудников распознано",
    employeeRecognized: "сотрудник распознан",
    clearAll: "Очистить всё",
    massDeleteConfirm: "Я понимаю, что это навсегда удалит",
    userAccount: "учётную запись пользователя",
    userAccounts: "учётные записи пользователей",
    andCannotBeUndone: "и это нельзя отменить.",
    deleteUsers: "Удалить",
    notFound: "Не найдено",

    // Poll edit / phase 2
    editPoll: "Редактировать опрос",
    pollDetails: "Детали опроса",
    editOptionsNote:
      "Изменение вариантов заменит все существующие. Уже поданные голоса сохранятся.",
    saveChanges: "Сохранить изменения",
    pollUpdated: "Опрос успешно обновлён!",
    reactivate: "Реактивировать",
    addPhase2: "Добавить этап 2",
    hasPhase2: "Есть этап 2",
    createPhase2: "Создать этап 2",
    phase2Label: "Этап 2",
    phase2Desc:
      "Этап 2 — дополнительный опрос, показываемый только сотрудникам, проголосовавшим за определённые варианты.",
    phase2TriggerLabel: "Показывать этап 2 сотрудникам, проголосовавшим за:",
    phase2TriggerDesc:
      "Выберите, какие ответы в родительском опросе активируют этот дополнительный вопрос.",
    phase2TriggersSelected: "вариант(ов) триггера выбрано",
    phase2PollConfig: "Конфигурация опроса этапа 2",
    phase2Created: "Опрос этапа 2 успешно создан!",
    phase2FollowUp: "Уточняющий вопрос",
    untitled: "Без названия",
    noCaption: "Без подписи",

    notificationsEnabled:
      "Уведомления включены! Вы будете получать уведомления о новых расчётных листках и опросах.",
    notificationsDisabled: "Уведомления отключены.",
    notificationsBlocked:
      "Уведомления заблокированы. Включите их в настройках браузера.",
    notificationsOn: "Уведомления включены",
    notificationsOff: "Включить уведомления",
    selectLanguage: "Выберите язык",

    // Admin Dashboard
    adminDashboardSubtitle: "Управление пользователями и расчётными листками",
    securityNotice: "Уведомление безопасности",
    securityNoticeText: "Вы можете скачать свои расчётные листки из вкладки",
    securityNoticeText2:
      "В целях конфиденциальности нельзя скачивать листки других сотрудников.",
    myPayslipsPersonal: "Это ваши личные расчётные листки для скачивания.",
    noPayslipsYet: "У вас ещё нет расчётных листков",
    noPublicationsYet: "Публикаций пока нет.",
    payslipPublications: "Публикации расчётных листков",
    managePublications: "Управление пакетными загрузками по месяцу/году",
    manageUsers: "Управление пользователями",
    massDelete: "Массовое удаление",
    batchUpload: "Пакетная загрузка",
    addNewUser: "Добавить пользователя",
    editUserTitle: "Редактировать пользователя",
    viewDetails: "Подробнее",
    uploaded: "Загружено",
    totalPages: "Всего страниц",
    successful: "Успешно",
    failed: "Ошибка",
    deleting: "Удаление...",
    uploading: "Загрузка...",
    allRoles: "Все роли",
    sortById: "По ID",
    sortByName: "По имени",
    sortByEmail: "По почте",
    sortByRole: "По роли",
    sortByDate: "По дате",
    clearFilters: "Сбросить фильтры",
    showing: "Показано",
    of: "из",
    itemsPerPage: "На странице",
    noUsersYet: "Пользователей пока нет",
    noUsersMatch: "Нет пользователей по фильтру",
    joined: "Присоединился",
    publicationDetails: "Детали публикации",
    batchUploadEmployees: "Пакетная загрузка сотрудников",
    batchUploadResults: "Результаты пакетной загрузки",
    uploadComplete: "Загрузка завершена",
    uploadEmployees: "Загрузить сотрудников",
    pageLabel: "Страница",
    employeeIdUnique: "Должен быть уникальным",
    emailOptional: "Email (необязательно)",
    leaveEmptyEmail: "Оставьте пустым, если не нужно",
    passwordMinChars: "Минимум 6 символов",
    changeEmployeeId: "Изменить ID сотрудника (должен быть уникальным)",
    newPasswordOptional: "Новый пароль (необязательно)",
    leaveEmptyPassword: "Оставьте пустым, чтобы сохранить текущий",
    welcomeEmployee: "Добро пожаловать",
    viewDownloadPayslips: "Просматривайте и скачивайте ваши расчётные листки",
    noPayslipsAvailable: "Нет расчётных листков",
    noPayslipsMessage:
      "У вас пока нет расчётных листков. Они появятся после загрузки отделом кадров.",
    enableNotifications: "Включить уведомления",
    notificationsDesc:
      "Получайте мгновенные уведомления о новых листках и опросах",
    enable: "Включить",
    monthLabel: "Месяц",
    fileName: "Имя файла",
    uploadDate: "Дата загрузки",
    actions: "Действия",
    downloadPDF: "Скачать PDF",
    confirmNewPassword: "Подтвердите новый пароль",
    passwordsDoNotMatch: "Новые пароли не совпадают",
    passwordTooShort: "Новый пароль должен содержать не менее 6 символов",
    passwordChangedSuccess: "Пароль успешно изменён!",
    searchPlaceholder: "Поиск по имени, ID или почте...",
    initialPassword: "Начальный пароль",
    worklogTab: "Табель",
    documentsTab: "Документы",
    uploadAndView: "Загрузка и просмотр",
    myForm106Tab: "Мой бланк 106",
    myWorklogTab: "Мой табель",
    worklogTitle: "Табель учёта",
    worklogAdminDesc:
      "Управление ежемесячными табелями учёта рабочего времени.",
    uploadWorklog: "Загрузить табель",
    worklogUploadTitle: "Пакетная загрузка табелей",
    worklogUploadDesc:
      "Загрузите PDF, где каждая страница — табель одного сотрудника. Система определит номер сотрудника на каждой странице.",
    noWorklogYet: "Табели ещё не загружены.",
    noWorklogAvailable: "Нет доступных табелей",
    noWorklogMessage:
      "Ваши табели появятся здесь после загрузки отделом кадров.",
    worklogPeriodAutoDetected: "Месяц и год определяются автоматически из PDF.",
    resetPassword: "Сбросить пароль",
    autoPasswordInfo:
      "Надёжный случайный пароль будет создан автоматически. Сотрудник будет обязан сменить его при первом входе. Посмотреть его можно в таблице пользователей.",
    reset2FA: "Сбросить 2FA",
    resetAuthenticator: "Сбросить аутентификатор",
    mustChangePasswordDesc:
      "В целях безопасности установите новый пароль. Минимум 6 символов и хотя бы 2 из следующих: заглавная буква (A-Z), строчная буква (a-z), цифра (0-9) или спецсимвол (!@#...).",
    passwordStrengthWeak: "Слабый",
    passwordComplexityHint:
      "Минимум 6 символов и 2 из: заглавная, строчная, цифра, спецсимвол (!@#...)",
    passwordStrengthFair: "Средний",
    passwordStrengthGood: "Хороший",
    passwordStrengthStrong: "Надёжный",
    passwordCheckLength: "Минимум 6 символов",
    passwordCheckUppercase: "Заглавная (A-Z)",
    passwordCheckLowercase: "Строчная (a-z)",
    passwordCheckDigit: "Цифра (0-9)",
    passwordCheckSpecial: "Спецсимвол (!@#$...)",
  },

  fr: {
    // Common
    welcome: "Bienvenue",
    loading: "Chargement...",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    close: "Fermer",
    back: "Retour",
    next: "Suivant",
    submit: "Soumettre",
    download: "Télécharger",
    upload: "Téléverser",
    search: "Rechercher",
    filter: "Filtrer",
    yes: "Oui",
    no: "Non",

    // Authentication
    signIn: "Se connecter",
    signOut: "Se déconnecter",
    email: "E-mail",
    password: "Mot de passe",
    employeeId: "ID employé",
    employeeIdOrEmail: "ID employé ou e-mail",
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    changePassword: "Changer le mot de passe",
    sessionExpired: "Votre session a expiré. Veuillez vous reconnecter.",
    forgotPassword:
      "Pour réinitialiser votre mot de passe, envoyez un message WhatsApp à Mata : 050-585-6068",

    // 2FA
    twoFactorAuth: "Authentification à deux facteurs",
    enable2FA: "Activer 2FA",
    disable2FA: "Désactiver 2FA",
    twoFAEnabled: "2FA activée",
    twoFARequired: "2FA requise",
    enterCode: "Entrez le code de votre application d'authentification",
    backupCode: "Code de sauvegarde",
    useBackupCode: "Utiliser un code de sauvegarde",
    useAuthenticatorCode: "Utiliser le code d'authentification",
    scanQRCode: "Scanner le code QR",
    setupTwoFA: "Configurer l'authentification à deux facteurs",
    disable2FAWarning:
      "La désactivation de 2FA rendra votre compte moins sécurisé. Vous n'aurez besoin que de votre mot de passe pour vous connecter.",
    confirmPassword2FA: "Confirmez votre mot de passe",

    // Authenticator mode
    authenticatorModeHint: "Entrez votre ID employé pour continuer",
    authenticatorSetupRequired:
      "Vous devez configurer un authentificateur avant de vous connecter",
    authenticatorSetupDesc:
      "Installez Google Authenticator ou une application similaire. Scannez le QR code et entrez le code à 6 chiffres pour confirmer.",
    authenticatorSaveBackupCodes:
      "Conservez ces codes en lieu sûr — ils vous seront nécessaires si vous perdez votre téléphone",
    authenticatorSetupComplete: "Continuer vers la connexion",
    or: "ou",

    // Dashboard
    dashboard: "Tableau de bord",
    adminDashboard: "Tableau de bord administrateur",
    employeeDashboard: "Tableau de bord employé",
    myPayslips: "Mes bulletins de paie",
    publications: "Publications",
    users: "Utilisateurs",
    polls: "Sondages et votes",

    // Payslips
    payslip: "Bulletin de paie",
    payslips: "Bulletins de paie",
    noPayslips: "Aucun bulletin de paie disponible",
    totalPayslips: "Total bulletins",
    latestPayslip: "Dernier bulletin",
    downloadPayslip: "Télécharger le bulletin",
    uploadPayslip: "Téléverser le bulletin",
    month: "Mois",
    year: "Année",
    uploadedAt: "Téléversé le",

    // Users
    addUser: "Ajouter un utilisateur",
    editUser: "Modifier l'utilisateur",
    deleteUser: "Supprimer l'utilisateur",
    fullName: "Nom complet",
    role: "Rôle",
    admin: "Administrateur",
    employee: "Employé",
    createdAt: "Créé le",

    // Months
    january: "Janvier",
    february: "Février",
    march: "Mars",
    april: "Avril",
    may: "Mai",
    june: "Juin",
    july: "Juillet",
    august: "Août",
    september: "Septembre",
    october: "Octobre",
    november: "Novembre",
    december: "Décembre",

    // Messages
    loginSuccess: "Connexion réussie",
    loginFailed: "Échec de la connexion. Veuillez réessayer.",
    passwordChanged: "Mot de passe modifié avec succès",
    twoFAEnabledSuccess:
      "2FA activée avec succès! Assurez-vous d'avoir sauvegardé vos codes de secours.",
    twoFADisabledSuccess:
      "2FA désactivée. Votre compte est maintenant moins sécurisé.",
    invalidCredentials: "Identifiants invalides",
    invalidCode: "Code invalide",

    // Settings
    settings: "Paramètres",
    language: "Langue",

    // Polls
    pollsManagement: "Gestion des sondages",
    pollsManagementSubtitle: "Créer et gérer les sondages des employés",
    createPoll: "Créer un sondage",
    createNewPoll: "Créer un nouveau sondage",
    pollResults: "Résultats du sondage",
    pollTitle: "Titre du sondage",
    pollDescription: "Description",
    pollOptions: "Options",
    pollClosesAt: "Se ferme le (facultatif)",
    allowMultipleChoice: "Autoriser le choix multiple",
    addOption: "Ajouter une option",
    captionOptional: "Légende (facultatif)",
    clickToAddPhoto: "Cliquez pour ajouter une photo",
    changePhoto: "Changer la photo",
    removePhoto: "Supprimer",
    creating: "Création...",
    exporting: "Export...",
    exportToExcel: "Exporter vers Excel",
    totalVotes: "Total des votes",
    votes: "votes",
    noActivePollsTitle: "Aucun sondage actif",
    noActivePollsDesc:
      "Aucun sondage disponible pour l'instant. Revenez plus tard !",
    noPollsYet: "Aucun sondage",
    noPollsYetDesc: "Créez votre premier sondage !",
    voted: "Voté",
    submitVote: "Voter",
    submitting: "Envoi...",
    thanksForVoting: "Merci pour votre vote !",
    collapse: "Réduire",
    changeVote: "Modifier le vote",
    updateVote: "Mettre à jour le vote",
    changingVote:
      "Vous modifiez votre vote. Sélectionnez une nouvelle option ci-dessous.",

    // Form 106
    form106Tab: "Formulaire 106",
    form106Title: "Formulaire 106",
    form106AdminDesc:
      "Gérer les documents fiscaux annuels Formulaire 106 pour les employés.",
    uploadForm106: "Télécharger le Formulaire 106",
    form106UploadTitle: "Téléchargement groupé du Formulaire 106",
    form106UploadDesc:
      "Téléchargez un PDF multi-pages où chaque page est un Formulaire 106 pour un employé. Le système détectera le numéro d'employé sur chaque page.",
    noForm106Available: "Aucun document Formulaire 106 disponible",
    noForm106Message:
      "Vos documents Formulaire 106 apparaîtront ici une fois téléchargés par les RH.",
    noForm106Yet: "Aucun document Formulaire 106 téléchargé pour l'instant.",
    totalForm106: "Total des documents Formulaire 106",
    failedToLoad: "Échec du chargement",
    downloadFailed: "Échec du téléchargement",
    deleteFailed: "Échec de la suppression",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cet enregistrement ?",
    form106SetupTitle: "Configurer l'extraction du Formulaire 106",
    form106SetupBtn: "Configurer",
    form106NotConfigured: "Non configuré",
    form106SetupStep1Title: "Télécharger un Formulaire 106 de référence",
    form106SetupStep1Desc:
      "Téléchargez un PDF du Formulaire 106. Nous afficherons la première page pour que vous puissiez cliquer sur le numéro d'employé.",
    form106SetupRendering: "Génération de l'aperçu PDF...",
    form106SetupChooseFile: "Choisir un fichier PDF",
    form106SetupStep2Title: "Cliquez sur le numéro d'employé",
    form106SetupStep2Desc:
      "Cliquez directement sur le numéro d'employé dans le document. Le système se calera sur le nombre le plus proche.",
    form106SetupStep2Tip:
      "💡 Conseil : cliquez sur les chiffres eux-mêmes, pas sur le libellé à côté.",
    form106SetupSelected: "Sélectionné",
    form106SetupClickSave: "cliquez sur Enregistrer pour confirmer",
    form106SetupSaveBtn: "Enregistrer la configuration",
    form106SetupSaved: "Configuration enregistrée !",
    form106SetupSavedDesc:
      "Les futurs téléchargements du Formulaire 106 utiliseront cette position pour trouver le numéro d'employé.",
    saving: "Enregistrement...",

    // Audit log
    logsTab: "Journaux",
    logsTitle: "Journal de sécurité",
    logsSubtitle: "Activité de connexion, tentatives échouées et alertes",
    logsSummaryTotal: "Total événements",
    logsSummaryAlerts: "Alertes",
    logsSummaryWarnings: "Avertissements",
    logsSummaryFailed24h: "Connexions échouées (24h)",
    logsSummarySuspicious: "Activité suspecte",
    logsLevelAll: "Tous les niveaux",
    logsLevelInfo: "Info",
    logsLevelWarn: "Avertissement",
    logsLevelAlert: "Alerte",
    logsEventAll: "Tous les événements",
    logsSearch: "Rechercher utilisateur, IP, détails...",
    logsColTime: "Heure",
    logsColLevel: "Niveau",
    logsColEvent: "Événement",
    logsColUser: "Utilisateur",
    logsColIp: "IP",
    logsColDetails: "Détails",
    logsNoEntries: "Aucune entrée trouvée",
    logsLoadMore: "Charger plus",
    logsRefresh: "Actualiser",
    logsEventLoginSuccess: "Connexion",
    logsEventLoginFailed: "Connexion échouée",
    logsEvent2faFailed: "Échec 2FA",
    logsEvent2faSuccess: "Succès 2FA",
    logsEventUnauthorized: "Accès non autorisé",
    logsEventSuspicious: "Activité suspecte",
    logsEventPasswordChanged: "Mot de passe modifié",
    logsEventAdminAction: "Action administrateur",
    logsEventBatchUpload: "Téléchargement groupé",
    logsEventBulkDelete: "Suppression en masse",

    leading: "En tête",
    yourChoice: "Votre choix",
    multipleChoiceHint: "Vous pouvez sélectionner plusieurs options",
    pollTitle_label: "Titre",
    pollStatus: "Statut",
    pollType: "Type",
    pollCloses: "Se ferme",
    multiChoice: "Choix multiple",
    multi: "Multiple",
    activate: "Activer",
    closePoll: "Fermer le sondage",
    results: "Résultats",
    pollCreated: "Sondage créé avec succès !",
    pollDeleted: "Sondage supprimé avec succès !",
    pollActivated: "Sondage activé avec succès !",
    pollClosed: "Sondage fermé avec succès !",
    confirmDeletePoll: "Êtes-vous sûr de vouloir supprimer ce sondage ?",
    optionsHint: "2–10, chacune nécessite une image ou une légende",
    pleaseSelectOption: "Veuillez sélectionner au moins une option",
    voteRecorded: "Vote enregistré avec succès !",
    employeesHaveVoted: "employés ont voté",
    employeeHasVoted: "employé a voté",

    // Batch Upload & Mass Delete Modals
    batchUploadPayslips: "Téléchargement groupé de fiches de paie",
    multiPagePDFUpload: "Téléchargement PDF multi-pages",
    multiPagePDFDesc:
      "Téléchargez un seul PDF contenant plusieurs fiches de paie (une par page). Le système extraira automatiquement le numéro d'employé de chaque page.",
    selectMonth: "Sélectionner un mois...",
    multiPagePDFFile: "Fichier PDF multi-pages",
    uploadBatch: "Télécharger le lot",
    uploadingFile: "Téléchargement du fichier…",
    sendingFile: "Envoi du fichier au serveur. Veuillez patienter.",
    processingPages: "Traitement des pages…",
    extractingPages: "Extraction des pages et correspondance des employés…",
    pageOf: "Page",
    processingBackground:
      "Vous pouvez fermer cette fenêtre — le traitement continuera en arrière-plan.",
    successfulPages: "réussis",
    failedPages: "échoués",
    outOf: "sur",
    pages: "pages",
    failedPagesList: "Pages échouées :",
    uploadFailed: "Échec du téléchargement",
    tryAgain: "Réessayer",
    closeProcessing: "Fermer (le traitement continue en arrière-plan)",
    massDeleteUsers: "Suppression massive d'utilisateurs",
    massDeleteDesc:
      "Entrez les numéros d'employés séparés par des espaces, virgules ou sauts de ligne.",
    employeeNumbers: "Numéros d'employés",
    massDeletePastePlaceholder: `Collez depuis Excel ou tapez manuellement :
1001 1002 1003
ou
1001, 1002, 1003`,
    employeesRecognized: "employés reconnus",
    employeeRecognized: "employé reconnu",
    clearAll: "Tout effacer",
    massDeleteConfirm: "Je comprends que cela supprimera définitivement",
    userAccount: "compte utilisateur",
    userAccounts: "comptes utilisateurs",
    andCannotBeUndone: "et ne peut pas être annulé.",
    deleteUsers: "Supprimer",
    notFound: "Introuvable",

    // Poll edit / phase 2
    editPoll: "Modifier le sondage",
    pollDetails: "Détails du sondage",
    editOptionsNote:
      "Modifier les options remplacera toutes les options existantes. Les votes déjà enregistrés seront conservés.",
    saveChanges: "Enregistrer les modifications",
    pollUpdated: "Sondage mis à jour avec succès !",
    reactivate: "Réactiver",
    addPhase2: "Ajouter phase 2",
    hasPhase2: "A une phase 2",
    createPhase2: "Créer phase 2",
    phase2Label: "Phase 2",
    phase2Desc:
      "La phase 2 est un sondage de suivi affiché uniquement aux employés ayant voté pour certaines options du sondage parent.",
    phase2TriggerLabel: "Afficher la phase 2 aux employés qui ont voté pour :",
    phase2TriggerDesc:
      "Sélectionnez quelles réponses du sondage parent déclenchent cette question de suivi.",
    phase2TriggersSelected: "option(s) déclencheuse(s) sélectionnée(s)",
    phase2PollConfig: "Configuration du sondage phase 2",
    phase2Created: "Sondage phase 2 créé avec succès !",
    phase2FollowUp: "Question de suivi",
    untitled: "Sans titre",
    noCaption: "Sans légende",

    notificationsEnabled:
      "Notifications activées ! Vous serez informé des nouvelles fiches de paie et sondages.",
    notificationsDisabled: "Notifications désactivées.",
    notificationsBlocked:
      "Notifications bloquées. Veuillez les activer dans les paramètres du navigateur.",
    notificationsOn: "Notifications activées",
    notificationsOff: "Activer les notifications",
    selectLanguage: "Sélectionner la langue",

    // Admin Dashboard
    adminDashboardSubtitle: "Gérer les utilisateurs et les bulletins de paie",
    securityNotice: "Avis de sécurité",
    securityNoticeText:
      "Vous pouvez télécharger vos propres bulletins depuis l'onglet",
    securityNoticeText2:
      "Pour la confidentialité, vous ne pouvez pas télécharger les bulletins d'autres employés.",
    myPayslipsPersonal:
      "Ce sont vos bulletins personnels que vous pouvez télécharger.",
    noPayslipsYet: "Vous n'avez pas encore de bulletins",
    noPublicationsYet: "Aucune publication pour l'instant.",
    payslipPublications: "Publications de bulletins de paie",
    managePublications: "Gérer les téléversements par mois/année",
    manageUsers: "Gérer les utilisateurs",
    massDelete: "Suppression en masse",
    batchUpload: "Téléversement groupé",
    addNewUser: "Ajouter un utilisateur",
    editUserTitle: "Modifier l'utilisateur",
    viewDetails: "Voir les détails",
    uploaded: "Téléversé",
    totalPages: "Total des pages",
    successful: "Réussi",
    failed: "Échoué",
    deleting: "Suppression...",
    uploading: "Téléversement...",
    allRoles: "Tous les rôles",
    sortById: "Trier par ID",
    sortByName: "Trier par nom",
    sortByEmail: "Trier par e-mail",
    sortByRole: "Trier par rôle",
    sortByDate: "Trier par date",
    clearFilters: "Effacer les filtres",
    showing: "Affichage",
    of: "sur",
    itemsPerPage: "Éléments par page",
    noUsersYet: "Aucun utilisateur",
    noUsersMatch: "Aucun utilisateur ne correspond",
    joined: "Rejoint le",
    publicationDetails: "Détails de la publication",
    batchUploadEmployees: "Téléversement groupé d'employés",
    batchUploadResults: "Résultats du téléversement groupé",
    uploadComplete: "Téléversement terminé",
    uploadEmployees: "Téléverser des employés",
    pageLabel: "Page",
    employeeIdUnique: "Doit être unique",
    emailOptional: "E-mail (facultatif)",
    leaveEmptyEmail: "Laissez vide si non nécessaire",
    passwordMinChars: "Minimum 6 caractères",
    changeEmployeeId: "Modifier l'ID employé (doit être unique)",
    newPasswordOptional: "Nouveau mot de passe (facultatif)",
    leaveEmptyPassword: "Laissez vide pour conserver l'actuel",
    welcomeEmployee: "Bienvenue",
    viewDownloadPayslips: "Consultez et téléchargez vos bulletins de paie",
    noPayslipsAvailable: "Aucun bulletin disponible",
    noPayslipsMessage:
      "Vous n'avez pas encore de bulletins. Ils apparaîtront après leur téléversement par les RH.",
    enableNotifications: "Activer les notifications",
    notificationsDesc:
      "Recevez des alertes instantanées pour les nouveaux bulletins et sondages",
    enable: "Activer",
    monthLabel: "Mois",
    fileName: "Nom du fichier",
    uploadDate: "Date de téléversement",
    actions: "Actions",
    downloadPDF: "Télécharger PDF",
    confirmNewPassword: "Confirmer le nouveau mot de passe",
    passwordsDoNotMatch: "Les nouveaux mots de passe ne correspondent pas",
    passwordTooShort:
      "Le nouveau mot de passe doit contenir au moins 6 caractères",
    passwordChangedSuccess: "Mot de passe modifié avec succès !",
    searchPlaceholder: "Rechercher par nom, ID ou e-mail...",
    initialPassword: "Mot de passe initial",
    worklogTab: "Journal de travail",
    documentsTab: "Documents",
    uploadAndView: "Téléverser et voir",
    myForm106Tab: "Mon formulaire 106",
    myWorklogTab: "Mon journal de travail",
    worklogTitle: "Journal de travail",
    worklogAdminDesc: "Gérer les journaux de travail mensuels des employés.",
    uploadWorklog: "Téléverser le journal",
    worklogUploadTitle: "Téléversement groupé des journaux de travail",
    worklogUploadDesc:
      "Téléversez un PDF multi-pages où chaque page est un journal de travail pour un employé. Le système détectera le numéro d'employé sur chaque page.",
    noWorklogYet: "Aucun journal de travail téléversé pour l'instant.",
    noWorklogAvailable: "Aucun journal de travail disponible",
    noWorklogMessage:
      "Vos journaux de travail apparaîtront ici après téléversement par les RH.",
    worklogPeriodAutoDetected:
      "Le mois et l'année sont détectés automatiquement depuis le PDF.",
    resetPassword: "Réinitialiser le mot de passe",
    autoPasswordInfo:
      "Un mot de passe sécurisé aléatoire sera généré automatiquement. L'employé devra le changer à la première connexion. Vous pouvez le consulter dans le tableau des utilisateurs.",
    reset2FA: "Réinitialiser 2FA",
    resetAuthenticator: "Réinitialiser l'authentificateur",
    mustChangePasswordDesc:
      "Pour des raisons de sécurité, choisissez un nouveau mot de passe. Il doit contenir au moins 6 caractères et inclure au moins 2 parmi : majuscule (A-Z), minuscule (a-z), chiffre (0-9) ou caractère spécial (!@#...).",
    passwordStrengthWeak: "Faible",
    passwordComplexityHint:
      "Minimum 6 caractères et 2 parmi : majuscule, minuscule, chiffre, caractère spécial (!@#...)",
    passwordStrengthFair: "Passable",
    passwordStrengthGood: "Bon",
    passwordStrengthStrong: "Fort",
    passwordCheckLength: "Au moins 6 caractères",
    passwordCheckUppercase: "Majuscule (A-Z)",
    passwordCheckLowercase: "Minuscule (a-z)",
    passwordCheckDigit: "Chiffre (0-9)",
    passwordCheckSpecial: "Spécial (!@#$...)",
  },
};

export type Language = "en" | "he" | "ru" | "fr";
export type TranslationKey = keyof typeof translations.en;
